// Canonical country list (source: CountryCode.xlsx provided by the Entra/business team).
// `name` is stored on groups and matched against a user's synced `country`.
// `code` is the corresponding ISO usageLocation, used for display.
export const COUNTRIES: { code: string; name: string }[] = [
  { code: "MY", name: "Malaysia" },
  { code: "VN", name: "Vietnam" },
  { code: "LA", name: "Laos" },
  { code: "ID", name: "Indonesia" },
  { code: "KR", name: "South Korea" },
  { code: "TH", name: "Thailand" },
  { code: "CN", name: "China" },
  { code: "NZ", name: "New Zealand" },
  { code: "TW", name: "Taiwan" },
  { code: "JP", name: "Japan" },
  { code: "SG", name: "Singapore" },
  { code: "AU", name: "Australia" },
  { code: "KH", name: "Cambodia" },
  { code: "CH", name: "Switzerland" },
  { code: "MM", name: "Myanmar" },
  { code: "PH", name: "Philippines" },
  { code: "HK", name: "Hong Kong" },
]

const NAME_TO_CODE = new Map(
  COUNTRIES.map((c) => [c.name.toLowerCase(), c.code])
)

// Look up the ISO code for a country name (case-insensitive). Returns undefined if unknown.
export const countryNameToCode = (name?: string | null): string | undefined =>
  name ? NAME_TO_CODE.get(name.trim().toLowerCase()) : undefined

// Format a country for display as "Name (CODE)", using the provided code or,
// if absent, looking it up from the country name. Falls back to the name alone.
export const formatCountry = (
  name?: string | null,
  code?: string | null
): string => {
  if (!name) return "-"
  const resolved = code || countryNameToCode(name)
  return resolved ? `${name} (${resolved})` : name
}
